import { useState, useCallback } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CTASection from "@/components/CTASection";
import GalleryLightbox from "@/components/GalleryLightbox";

// Hardwood gallery images
import hardwood1 from "@/assets/gallery/hardwood-install-1.jpg";
import hardwood2 from "@/assets/gallery/hardwood-install-2.jpg";
import hardwood3 from "@/assets/gallery/hardwood-install-3.jpg";
import hardwood4 from "@/assets/gallery/hardwood-install-4.jpg";
import hardwood5 from "@/assets/gallery/hardwood-install-5.jpg";
import hardwood6 from "@/assets/gallery/hardwood-install-6.jpg";
import hardwood7 from "@/assets/gallery/hardwood-install-7.jpg";
import hardwood8 from "@/assets/gallery/hardwood-install-8.jpg";
import hardwood9 from "@/assets/gallery/hardwood-install-9.jpg";

// Sand & Finish gallery images
import sandFinish1 from "@/assets/gallery/sand-finish-1.jpg";
import sandFinish2 from "@/assets/gallery/sand-finish-2.jpg";
import sandFinish3 from "@/assets/gallery/sand-finish-3.jpg";
import sandFinish4 from "@/assets/gallery/sand-finish-4.jpg";
import sandFinish5 from "@/assets/gallery/sand-finish-5.jpg";
import sandFinish6 from "@/assets/gallery/sand-finish-6.jpg";
import sandFinish7 from "@/assets/gallery/sand-finish-7.jpg";
import sandFinish8 from "@/assets/gallery/sand-finish-8.jpg";
import sandFinish9 from "@/assets/gallery/sand-finish-9.jpg";
import sandFinish10 from "@/assets/gallery/sand-finish-10.jpg";
import sandFinish11 from "@/assets/gallery/sand-finish-11.png";
import sandFinish12 from "@/assets/gallery/sand-finish-12.jpg";
import sandFinish13 from "@/assets/gallery/sand-finish-13.jpg";
import sandFinish14 from "@/assets/gallery/sand-finish-14.jpg";
import sandFinish15 from "@/assets/gallery/sand-finish-15.jpg";
import sandFinish16 from "@/assets/gallery/sand-finish-16.jpg";
import sandFinish17 from "@/assets/gallery/sand-finish-17.jpg";

// LVP gallery images
import lvp1 from "@/assets/gallery/lvp-install-1.jpg";
import lvp2 from "@/assets/gallery/lvp-install-2.jpg";
import lvp3 from "@/assets/gallery/lvp-install-3.jpg";
import lvp4 from "@/assets/gallery/lvp-install-4.jpg";
import lvp5 from "@/assets/gallery/lvp-install-5.jpg";
import lvp6 from "@/assets/gallery/lvp-install-6.jpg";

// Stairs gallery images
import stairs1 from "@/assets/gallery/stairs-1.jpg";
import stairs2 from "@/assets/gallery/stairs-2.jpg";
import stairs3 from "@/assets/gallery/stairs-3.jpg";
import stairs4 from "@/assets/gallery/stairs-4.jpg";
import stairs5 from "@/assets/gallery/stairs-5.jpg";
import stairs6 from "@/assets/gallery/stairs-6.jpg";
type GalleryCategory = "all" | "hardwood" | "sand-finish" | "lvp" | "stairs";
interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  category: GalleryCategory;
}
const galleryImages: GalleryImage[] = [
// Hardwood
{
  id: 1,
  src: hardwood1,
  alt: "Hardwood nail-down installation in progress",
  category: "hardwood"
}, {
  id: 2,
  src: hardwood2,
  alt: "Hardwood flooring with pneumatic nailer",
  category: "hardwood"
}, {
  id: 3,
  src: hardwood3,
  alt: "Floor preparation and filler application",
  category: "hardwood"
}, {
  id: 4,
  src: hardwood4,
  alt: "Applying finish to hardwood floors",
  category: "hardwood"
}, {
  id: 15,
  src: hardwood5,
  alt: "Large open floor plan hardwood installation",
  category: "hardwood"
}, {
  id: 16,
  src: hardwood6,
  alt: "Hardwood installation with vapor barrier",
  category: "hardwood"
}, {
  id: 29,
  src: hardwood7,
  alt: "Entry foyer with tile inlay and dark stained hardwood border",
  category: "hardwood"
}, {
  id: 30,
  src: hardwood8,
  alt: "Hardwood floor board repair in progress",
  category: "hardwood"
}, {
  id: 31,
  src: hardwood9,
  alt: "Hardwood floor patching and repair work",
  category: "hardwood"
},
// Sand & Finish
{
  id: 5,
  src: sandFinish1,
  alt: "Finished hallway with natural wood tones",
  category: "sand-finish"
}, {
  id: 6,
  src: sandFinish2,
  alt: "Floor sanding with drum sander",
  category: "sand-finish"
}, {
  id: 7,
  src: sandFinish3,
  alt: "Applying polyurethane finish",
  category: "sand-finish"
}, {
  id: 8,
  src: sandFinish4,
  alt: "Floor buffing with orbital sander",
  category: "sand-finish"
}, {
  id: 9,
  src: sandFinish5,
  alt: "Finished living room with fireplace",
  category: "sand-finish"
}, {
  id: 10,
  src: sandFinish6,
  alt: "Fresh coat of finish drying",
  category: "sand-finish"
}, {
  id: 11,
  src: sandFinish7,
  alt: "Before and after sanding comparison",
  category: "sand-finish"
}, {
  id: 12,
  src: sandFinish8,
  alt: "Edge sanding detail work",
  category: "sand-finish"
}, {
  id: 13,
  src: sandFinish9,
  alt: "Dark stained hardwood floors",
  category: "sand-finish"
}, {
  id: 14,
  src: sandFinish10,
  alt: "Glossy finished oak floors",
  category: "sand-finish"
}, {
  id: 32,
  src: sandFinish11,
  alt: "Before and after hardwood floor refinishing",
  category: "sand-finish"
}, {
  id: 33,
  src: sandFinish12,
  alt: "Light maple kitchen floors with natural finish",
  category: "sand-finish"
}, {
  id: 34,
  src: sandFinish13,
  alt: "Living room with fireplace and refinished oak floors",
  category: "sand-finish"
}, {
  id: 35,
  src: sandFinish14,
  alt: "Kitchen prep work with protective plastic covering",
  category: "sand-finish"
}, {
  id: 36,
  src: sandFinish15,
  alt: "Kitchen floor sanding in progress with equipment",
  category: "sand-finish"
}, {
  id: 37,
  src: sandFinish16,
  alt: "Glossy maple entryway floor refinish",
  category: "sand-finish"
}, {
  id: 38,
  src: sandFinish17,
  alt: "Multi-room refinishing with protective masking",
  category: "sand-finish"
},
// LVP
{
  id: 17,
  src: lvp1,
  alt: "LVP flooring in bedroom with natural wood look",
  category: "lvp"
}, {
  id: 18,
  src: lvp2,
  alt: "Wide plank LVP installation in sunlit room",
  category: "lvp"
}, {
  id: 19,
  src: lvp3,
  alt: "Grey LVP in open concept living room",
  category: "lvp"
}, {
  id: 20,
  src: lvp4,
  alt: "Dark walnut LVP installation in progress",
  category: "lvp"
}, {
  id: 21,
  src: lvp5,
  alt: "Light grey LVP with built-in shelving",
  category: "lvp"
}, {
  id: 22,
  src: lvp6,
  alt: "LVP flooring in vaulted ceiling living room",
  category: "lvp"
},
// Stairs
{
  id: 23,
  src: stairs1,
  alt: "Curved oak staircase with custom railing",
  category: "stairs"
}, {
  id: 24,
  src: stairs2,
  alt: "Spiral staircase finishing in progress",
  category: "stairs"
}, {
  id: 25,
  src: stairs3,
  alt: "Custom bullnose stair treads and risers",
  category: "stairs"
}, {
  id: 26,
  src: stairs4,
  alt: "Natural maple stair installation",
  category: "stairs"
}, {
  id: 27,
  src: stairs5,
  alt: "LVP stair treads with protective taping",
  category: "stairs"
}, {
  id: 28,
  src: stairs6,
  alt: "Dark stained oak staircase refinish",
  category: "stairs"
}];
const categories = [{
  id: "all" as const,
  label: "All Work"
}, {
  id: "hardwood" as const,
  label: "Hardwood"
}, {
  id: "sand-finish" as const,
  label: "Sand & Finish"
}, {
  id: "lvp" as const,
  label: "LVP"
}, {
  id: "stairs" as const,
  label: "Stairs"
}];
const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState<GalleryCategory>("all");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const filteredImages = activeCategory === "all" ? galleryImages : galleryImages.filter(img => img.category === activeCategory);

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const goToPrevious = useCallback(() => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? filteredImages.length - 1 : prev - 1
    );
  }, [filteredImages.length]);

  const goToNext = useCallback(() => {
    setCurrentImageIndex((prev) => 
      prev === filteredImages.length - 1 ? 0 : prev + 1
    );
  }, [filteredImages.length]);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-primary py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary-foreground mb-4">
              Our Work
            </h1>
            <p className="text-primary-foreground/80 text-lg max-w-2xl mx-auto">
              Browse our portfolio of completed flooring projects throughout Colorado Springs.
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-muted border-b border-border">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center gap-4">
              {categories.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`font-heading font-medium uppercase tracking-wide text-sm px-6 py-3 rounded transition-all duration-200 ${
                    activeCategory === cat.id
                      ? "bg-accent text-accent-foreground"
                      : "bg-card text-foreground hover:bg-accent/10"
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="py-16 bg-background">
          <div className="container mx-auto px-4">
            {filteredImages.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredImages.map((image, index) => (
                  <button
                    key={image.id}
                    onClick={() => openLightbox(index)}
                    className="aspect-[4/3] rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 bg-muted group cursor-pointer"
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover border-4 border-accent border-solid shadow-md group-hover:scale-105 transition-transform duration-300"
                    />
                  </button>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-muted-foreground text-lg">
                  Gallery photos coming soon. Check back for examples of our work!
                </p>
              </div>
            )}
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />

      {/* Lightbox */}
      <GalleryLightbox
        images={filteredImages}
        currentIndex={currentImageIndex}
        isOpen={lightboxOpen}
        onClose={closeLightbox}
        onPrevious={goToPrevious}
        onNext={goToNext}
      />
    </div>
  );
};

export default Gallery;